import React, { useEffect } from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import { useForm, Controller } from "react-hook-form";
import MenuItem from "@material-ui/core/MenuItem";
import { TextField, FormHelperText, Button, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import { useState } from "react";
import GooglePlaceAutoComplete, { PlaceDetails } from "../../shared/GooglePlaceAutoComplete";
import api from "../../../store/api";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { useSelector } from "react-redux";
import Snackbar from "@material-ui/core/Snackbar";
import { RootState } from "../../../store/rootReducer";
import CircularProgress from "@material-ui/core/CircularProgress";
import LinearProgress from "@material-ui/core/LinearProgress";
import submitData from "../submitData";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { PermissionAccessLevel, PermissionType } from "../../../common/types";
import { useHistory } from "react-router-dom";

export interface OriginDestinationData {
  originCustomerLocationId: string | null;
  originWardId?: string;
  originBed?: string;
  originGooglePlaceId: string | null;
  originName?: string;
  originLongitude: number | null;
  originLatitude: number | null;
  originNote: string;
  destinationCustomerLocationId: string | null;
  destinationBed?: string;
  destinationGooglePlaceId: string | null;
  destinationName?: string;
  destinationLongitude: number | null;
  destinationLatitude: number | null;
  destinationNote: string;
  returnTrip: boolean;
  escortRequired: boolean;
  destinationWardId?: string;
  fromCustomerLocationName: string;
  toCustomerLocationName: string;
  fromWardName: string;
  toWardName: string;
  originStreetAddress: string | null;
  originState: string | null;
  originSuburb: string | null;
  originPostcode: string | null;
  destinationStreetAddress: string | null;
  destinationState: string | null;
  destinationSuburb: string | null;
  destinationPostcode: string | null;
  originGooglePlaceDetails: PlaceDetails | null;
  destinationGooglePlaceDetails: PlaceDetails | null;
}

export interface SelectItem extends React.Props<any> {
  text: string | undefined;
  value: string | undefined;
  selected: boolean;
  deleted: boolean;
}
const useStyles = makeStyles((theme) => ({
  formRow: {},
  formControlLabel: {
    fontSize: 18,
    color: "#4A4A4A",
    padding: theme.spacing(0, 0, 1, 0),
  },
  helpText: {
    color: "red",
    padding: theme.spacing(0, 0, 0, 2),
  },
  recentLocationList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    "& li": {
      margin: "5px 0px",
    },
    "& li a": {
      textDecoration: "none",
    },
  },
  dropdownIcon: {
    top: 4,
  },
}));

const OriginDestination = ({ NextButton, handleData, data, saveChangesState, isEdit, dispatch }: any) => {
  const { authStore } = useSelector((state: RootState) => state);
  const classes = useStyles();
  const { handleSubmit, watch, errors, control, formState, setValue, getValues, setError, trigger } = useForm();
  const [fromMode, setFromMode] = useState(0);
  const [toMode, setToMode] = useState(1);
  const [customerLocations, setCustomerLocations] = useState<SelectItem[]>([]);
  const [fromWards, setFromWards] = useState<SelectItem[]>([]);
  const [toWards, setToWards] = useState<SelectItem[]>([]);
  const [recentLocations, setRecentLocations] = useState<SelectItem[]>([]);
  const [existingFromLocationId, setExistingFromLocationId] = useState("");
  const [existingToLocationId, setExistingToLocationId] = useState("");
  const [fromCustomerLocationName, setFromCustomerLocationName] = useState("");
  const [toCustomerLocationName, setToCustomerLocationName] = useState("");
  const [fromWardName, setFromWardName] = useState("");
  const [toWardName, setToWardName] = useState("");
  const [toastAlert, setToastAlert] = useState({ open: false, message: "" });
  const [loadingWardsFrom, setLoadingWardsFrom] = useState(false);
  const [loadingWardsTo, setLoadingWardsTo] = useState(false);
  const [originGooglePlaceDetails, setOriginGooglePlaceDetails] = useState<PlaceDetails | null>(null);
  const [destinationGooglePlaceDetails, setDestinationGooglPlaceDetails] = useState<PlaceDetails | null>(null);
  const [reverseMode, setReverseMode] = useState(true);
  const [defaultWardId, setDefaultWardId] = useState("");
  const history = useHistory();
  const [currentOriginDetails, setCurrentOriginDetails] = useState<any>({
    customerLocation: "",
    bed: "",
    wards: [],
    wardId: "",
    googlePlaceDetails: null,
    note: "",
  });
  const [currentDestinationDetails, setCurrentDestinationDetails] = useState<any>({
    customerLocation: "",
    bed: "",
    wards: [],
    wardId: "",
    googlePlaceDetails: null,
    note: "",
  });
  const handleNext = async (data: any): Promise<any> => {
    // Here we can do validations
    var returnData: OriginDestinationData = {
      originCustomerLocationId: fromMode !== 0 ? null : data.fromCustomerLocation,
      originWardId: fromMode !== 0 || data.fromWard === "" ? null : data.fromWard,
      originBed: fromMode !== 0 ? null : data.originBed,
      originNote: data.originNote,
      originStreetAddress:
        fromMode !== 0 && originGooglePlaceDetails !== null
          ? originGooglePlaceDetails.address_details.home + " " + originGooglePlaceDetails.address_details.street
          : null,
      originSuburb: fromMode !== 0 && originGooglePlaceDetails !== null ? originGooglePlaceDetails.address_details.city : null,
      originState: fromMode !== 0 && originGooglePlaceDetails !== null ? originGooglePlaceDetails.address_details.region : null,
      originPostcode: fromMode !== 0 && originGooglePlaceDetails !== null ? originGooglePlaceDetails.address_details.postal_code : null,
      originGooglePlaceId: fromMode !== 0 && originGooglePlaceDetails !== null ? originGooglePlaceDetails.place_id : null,
      originName:
        fromMode !== 0 && originGooglePlaceDetails !== null && originGooglePlaceDetails.types.indexOf("establishment") > -1
          ? originGooglePlaceDetails.name
          : "",
      originLatitude: fromMode !== 0 && originGooglePlaceDetails !== null ? originGooglePlaceDetails.lat : null,
      originLongitude: fromMode !== 0 && originGooglePlaceDetails !== null ? originGooglePlaceDetails.lng : null,
      destinationCustomerLocationId: toMode !== 0 ? null : data.toCustomerLocation,
      destinationWardId: toMode !== 0 || data.toWard === "" ? null : data.toWard,
      destinationBed: toMode !== 0 ? null : data.destinationBed,
      destinationNote: data.destinationNote,
      destinationGooglePlaceId: toMode !== 0 && destinationGooglePlaceDetails !== null ? destinationGooglePlaceDetails.place_id : null,
      destinationName:
        toMode !== 0 && destinationGooglePlaceDetails !== null && destinationGooglePlaceDetails.types.indexOf("establishment") > -1
          ? destinationGooglePlaceDetails.name
          : "",
      destinationLatitude: toMode !== 0 && destinationGooglePlaceDetails !== null ? destinationGooglePlaceDetails.lat : null,
      destinationLongitude: toMode !== 0 && destinationGooglePlaceDetails !== null ? destinationGooglePlaceDetails.lng : null,
      destinationStreetAddress:
        toMode !== 0 && destinationGooglePlaceDetails !== null
          ? destinationGooglePlaceDetails.address_details.home + " " + destinationGooglePlaceDetails.address_details.street
          : null,
      destinationSuburb: toMode !== 0 && destinationGooglePlaceDetails !== null ? destinationGooglePlaceDetails.address_details.city : null,
      destinationState: toMode !== 0 && destinationGooglePlaceDetails !== null ? destinationGooglePlaceDetails.address_details.region : null,
      destinationPostcode: toMode !== 0 && destinationGooglePlaceDetails !== null ? destinationGooglePlaceDetails.address_details.postal_code : null,
      returnTrip: data.returnTrip,
      escortRequired: data.escortRequired,
      fromCustomerLocationName: fromMode !== 0 ? "" : fromCustomerLocationName,
      toCustomerLocationName: toMode !== 0 ? "" : toCustomerLocationName,
      fromWardName: fromMode !== 0 ? "" : fromWardName,
      toWardName: toMode !== 0 ? "" : toWardName,
      originGooglePlaceDetails,
      destinationGooglePlaceDetails,
    };
    handleData(returnData);
    return returnData;
  };

  const onNextButtonClick = async (): Promise<boolean> => {
    const isValid = await trigger();
    if (isValid) {
      await handleNext(getValues());
    }
    return isValid;
  };

  const saveChanges = async (update = false) => {
    const isValid = await trigger();
    if (isValid) {
      const formData = await handleNext(getValues());
      if (update == true) submitData({ ...data, ...formData }, dispatch, history);
    }
  };

  React.useEffect(() => {
    saveChangesState[1](() => saveChanges);
  }, [toMode, fromMode, data]);

  React.useEffect(() => {
    loadData();
  }, []);

    React.useEffect(() => {
        if (existingFromLocationId != "") {
            data.originCustomerLocationId = existingFromLocationId;
            setFromMode(0);
            setValue("fromCustomerLocation", existingFromLocationId);
            getFromWardsData(existingFromLocationId, true);
            setExistingFromLocationId("");
        }
    }, [existingFromLocationId]);

    React.useEffect(() => {
        if (existingToLocationId != "") {
            data.destinationCustomerLocationId = existingToLocationId;
            setToMode(0);
            setValue("toCustomerLocation", existingToLocationId);
            getToWardsData(existingToLocationId, true);
            setExistingToLocationId("");
        }
    }, [existingToLocationId]);

  const loadData = async (): Promise<void> => {
    setToastAlert({ open: true, message: "Processing . . ." });

    await getRecentlyUsedLocations();

    if (data !== undefined && data !== null) {
      await getLocationsData(false);

      setValue("returnTrip", data.returnTrip ?? false);
      setValue("escortRequired", data.escortRequired ?? false);
      setValue("originNote", data.originNote || "");
      if (data.originCustomerLocationId) {
        setValue("fromCustomerLocation", data.originCustomerLocationId);
        setValue("originBed", data.originBed || "");
        await getFromWardsData(data.originCustomerLocationId, false);
        setValue("fromWard", data.originWardId || data.originWardId || "");
      } else if (data.originGooglePlaceId) {
        setFromMode(1);
        setValue("fromOtherLocation", data.originGooglePlaceId ?? null);
      }

      setValue("destinationNote", data.destinationNote || "");
      if (data.destinationCustomerLocationId) {
        setToMode(0);
        setValue("toCustomerLocation", data.destinationCustomerLocationId);
        setValue("destinationBed", data.destinationBed || "");
        await getToWardsData(data.destinationCustomerLocationId, false);
        setValue("toWard", data.destinationWardId || data.destinationWardId || "");
      } else if (data.destinationGooglePlaceId) {
        setValue("toOtherLocation", data.destinationGooglePlaceId ?? null);
      }

      if (
        !data.destinationCustomerLocationId &&
        !data.originCustomerLocationId &&
        !data.destinationGooglePlaceId &&
        !data.destinationCustomerLocationId
      ) {
        await getLocationsData(true);
      }
    } else {
      await getLocationsData(true);
    }
    setToastAlert({ open: false, message: "" });
  };

  const getRecentlyUsedLocations = async (): Promise<void> => {
    try {
      const recentLocations = localStorage.getItem("recentLocations");
      if (recentLocations) {
        setRecentLocations(JSON.parse(recentLocations));
      }
      const res = await api.getRecentlyUsedLocations("");
      setRecentLocations(res.data.model);
    } catch {}
  };

  const getLocationsData = async (showDefault: boolean): Promise<void> => {
    try {
      const customerLocations = localStorage.getItem("customerLocations");
      let res: SelectItem[] = [];

      if (customerLocations) {
        res = JSON.parse(customerLocations);
        setCustomerLocations(res);
      } else {
        const apiData = await api.getCustomerLocations("");
        res = apiData.data.model ?? [];
        localStorage.setItem("customerLocations", JSON.stringify(apiData.data.model));
        setCustomerLocations(res);
      }
      if (showDefault && res.length == 1 && res[0].value) {
        if (fromMode == 0) {
          setValue("fromCustomerLocation", res[0].value);
          await getFromWardsData(res[0].value, true);
        }
        if (toMode == 0) {
          setValue("toCustomerLocation", res[0].value);
          await getToWardsData(res[0].value, true);
        }
      }
    } catch {}
  };

  const getFromWardsData = async (locationId: string, showDefault: boolean): Promise<void> => {
    try {
      setLoadingWardsFrom(true);
      let myWardId = "";
      const res = await api.getWardsInLocation("locationId=" + locationId);
      try {
        const myWardRes = await api.getMyWard("");
        if (myWardRes.data && myWardRes.data.model) {
          myWardId = myWardRes.data.model.wardId;
        }
      } catch {}
      const perRes = await api.getMyObjectAccessPermission("Booking", isEdit ? PermissionType.Edit : PermissionType.Create);
      setLoadingWardsFrom(false);
      if (perRes === PermissionAccessLevel.None) {
        setFromWards([]);
      } else if (perRes === PermissionAccessLevel.Ward) {
        if (myWardId) {
          setDefaultWardId(myWardId);
        }
        setFromWards(res.data.model ? res.data.model.filter((w: any) => w.value == myWardId) : []);
      } else {
        setFromWards(res.data.model ?? []);
      }
      if (showDefault && res.data.model) {
        if (!defaultWardId && myWardId) {
          setDefaultWardId(myWardId);
        }
        if (res.data.model.some((w: any) => w.value == myWardId)) {
          setValue("fromWard", myWardId);
        }
      }
    } catch {
      setLoadingWardsFrom(false);
    }
  };

  const getToWardsData = async (locationId: string, showDefault: boolean): Promise<void> => {
    try {
      setLoadingWardsTo(true);
      let myWardId = "";
      const res = await api.getWardsInLocation("locationId=" + locationId);
      try {
        const myWardRes = await api.getMyWard("");
        if (myWardRes.data && myWardRes.data.model) {
          myWardId = myWardRes.data.model.wardId;
        }
      } catch {}
      const perRes = await api.getMyObjectAccessPermission("Booking", isEdit ? PermissionType.Edit : PermissionType.Create);
      setLoadingWardsTo(false);

      if (perRes === PermissionAccessLevel.None) {
        setToWards([]);
      } else if (perRes === PermissionAccessLevel.Ward) {
        if (myWardId) {
          setDefaultWardId(myWardId);
        }
        setToWards(res.data.model ? res.data.model.filter((w: any) => w.value == myWardId) : []);
      } else {
        setToWards(res.data.model ?? []);
      }
      if (showDefault && res.data.model && res.data.model.length == 1) {
        let myWardId = "";
        if (!defaultWardId && myWardId) {
          setDefaultWardId(myWardId);
        }
        if (res.data.model.some((w: any) => w.value == myWardId)) {
          setValue("toWard", myWardId);
        }
      }
    } catch {
      setLoadingWardsTo(false);
    }
  };

  const renderFromLocation = (): JSX.Element => {
    if (fromMode === 0) {
      return (
        <React.Fragment>
          <Grid item xs={12} className={classes.formRow}>
            <Controller
              name="fromCustomerLocation"
              defaultValue=""
              control={control}
              render={({ onChange, onBlur, value, name }) => (
                <React.Fragment>
                  <Select
                    onChange={(e) => {
                      setFromWards([]);
                      if (e.target.value !== "") {
                        getFromWardsData(String(e.target.value), true);
                        setFromCustomerLocationName(customerLocations.find((item) => item.value == e.target.value)?.text || "");
                      }

                      onChange(e);
                    }}
                    value={value}
                    name={name}
                    IconComponent={KeyboardArrowDownIcon}
                    fullWidth={true}
                    classes={{ icon: classes.dropdownIcon }}
                    variant="outlined"
                  >
                    <MenuItem key="None" defaultValue="" value="">
                      None
                    </MenuItem>
                    {customerLocations
                      .filter((item) => item.deleted != true)
                      .map((item) => (
                        <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>
                          {item.text}
                        </MenuItem>
                      ))}
                  </Select>
                  <FormHelperText className={classes.helpText}>
                    {errors.fromCustomerLocation ? errors.fromCustomerLocation.message : ""}
                  </FormHelperText>
                </React.Fragment>
              )}
              rules={{
                validate: (value) => {
                  if (value === null || (value === "" && fromMode === 0)) {
                    return "Location is required";
                  }
                },
              }}
            />
          </Grid>
          <Grid item xs={8} className={classes.formRow}>
            <div className={classes.formControlLabel}>Ward</div>
            <Controller
              name="fromWard"
              defaultValue=""
              control={control}
              render={({ onChange, onBlur, value, name }) => (
                <React.Fragment>
                  <Select
                    onBlur={onBlur}
                    value={value}
                    name={name}
                    onChange={(e) => {
                      setFromWardName(fromWards.find((item) => item.value == e.target.value)?.text || "");
                      onChange(e);
                    }}
                    fullWidth={true}
                    IconComponent={KeyboardArrowDownIcon}
                    classes={{ icon: classes.dropdownIcon }}
                    variant="outlined"
                  >
                    <MenuItem key="None" defaultValue="" value="">
                      None
                    </MenuItem>
                    {fromWards
                      .filter((item) => item.deleted != true)
                      .map((item) => (
                        <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>
                          {item.text}
                        </MenuItem>
                      ))}
                  </Select>
                  <FormHelperText className={classes.helpText}>{errors.fromWard ? errors.fromWard.message : ""}</FormHelperText>
                  {loadingWardsFrom && <LinearProgress style={{ position: "relative", top: -6 }} />}
                </React.Fragment>
              )}
              rules={{}}
            />
          </Grid>
          <Grid item xs={4} className={classes.formRow}>
            <div className={classes.formControlLabel}>Bed</div>
            <Controller
              name="originBed"
              defaultValue=""
              control={control}
              as={<TextField variant="outlined" error={errors.originBed} helperText={errors.originBed ? errors.originBed.message : ""} />}
              rules={{}}
            />
          </Grid>
        </React.Fragment>
      );
    } else {
      return (
        <Grid item xs={12} className={classes.formRow}>
          <Controller
            name="fromOtherLocation"
            defaultValue=""
            control={control}
            render={({ onChange, onBlur, value, name }) => (
              <GooglePlaceAutoComplete
                placeholder="Location name or address"
                    onChange={async(value: any) => {
                  setOriginGooglePlaceDetails(value);
                        if (value) {
                            const res = await api.isCustomerLocationExist("placeID=" + value.place_id);
                            if (res.data.model == "")
                                onChange(value.place_id);
                            else
                                setExistingFromLocationId(res.data.model);
                  } else {
                    onChange(null);
                  }
                }}
                value={value}
                name={name}
                onBlur={onBlur}
                error={errors.fromOtherLocation}
                errorMessage={errors.fromOtherLocation ? errors.fromOtherLocation.message : ""}
              />
            )}
            rules={{
              validate: (value) => {
                if ((!value === null || !originGooglePlaceDetails) && fromMode === 1) {
                  return "Location is required";
                }
              },
            }}
          />
        </Grid>
      );
    }
  };

  const renderToLocation = (): JSX.Element => {
    if (toMode === 0) {
      return (
        <React.Fragment>
          <Grid item xs={12} className={classes.formRow}>
            <Controller
              name="toCustomerLocation"
              defaultValue=""
              control={control}
              render={({ onChange, onBlur, value, name }) => (
                <React.Fragment>
                  <Select
                    onChange={(e) => {
                      setToWards([]);
                      if (e.target.value !== "") {
                        getToWardsData(String(e.target.value), true);
                        setToCustomerLocationName(customerLocations.find((item) => item.value == e.target.value)?.text || "");
                      }

                      onChange(e);
                    }}
                    name={name}
                    value={value}
                    IconComponent={KeyboardArrowDownIcon}
                    fullWidth={true}
                    variant="outlined"
                  >
                    <MenuItem key="None" defaultValue="" value="">
                      None
                    </MenuItem>
                    {customerLocations
                      .filter((item) => item.deleted != true)
                      .map((item) => (
                        <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>
                          {item.text}
                        </MenuItem>
                      ))}
                  </Select>
                  <FormHelperText className={classes.helpText}>{errors.toCustomerLocation ? errors.toCustomerLocation.message : ""}</FormHelperText>
                </React.Fragment>
              )}
              rules={{
                validate: (value) => {
                  if (value === null || (value === "" && toMode === 0)) {
                    return "Location is required";
                  }
                },
              }}
            />
          </Grid>
          <Grid item xs={8} className={classes.formRow}>
            <div className={classes.formControlLabel}>Ward</div>
            <Controller
              name="toWard"
              defaultValue=""
              control={control}
              render={({ onChange, onBlur, value, name }) => (
                <React.Fragment>
                  <Select
                    onChange={(e) => {
                      setToWardName(toWards.find((item) => item.value == e.target.value)?.text || "");
                      onChange(e);
                    }}
                    name={name}
                    value={value}
                    IconComponent={KeyboardArrowDownIcon}
                    fullWidth={true}
                    variant="outlined"
                  >
                    <MenuItem key="None" defaultValue="" value="">
                      None
                    </MenuItem>
                    {toWards
                      .filter((item) => item.deleted != true)
                      .map((item) => (
                        <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>
                          {item.text}
                        </MenuItem>
                      ))}
                  </Select>
                  <FormHelperText className={classes.helpText}>{errors.toWard ? errors.toWard.message : ""}</FormHelperText>
                  {loadingWardsTo && <LinearProgress style={{ position: "relative", top: -6 }} />}
                </React.Fragment>
              )}
              rules={{}}
            />
          </Grid>
          <Grid item xs={4} className={classes.formRow}>
            <div className={classes.formControlLabel}>Bed</div>
            <Controller
              name="destinationBed"
              defaultValue=""
              control={control}
              as={
                <TextField variant="outlined" error={errors.destinationBed} helperText={errors.destinationBed ? errors.destinationBed.message : ""} />
              }
              rules={{}}
            />
          </Grid>
        </React.Fragment>
      );
    } else {
      return (
        <Grid item xs={12} className={classes.formRow}>
          <Controller
            name="toOtherLocation"
            defaultValue=""
            control={control}
            render={({ onChange, onBlur, value, name }) => (
              <GooglePlaceAutoComplete
                placeholder="Location name or address"
                    onChange={async (value: any) => {
                  setDestinationGooglPlaceDetails(value);
                        if (value) {
                            const res = await api.isCustomerLocationExist("placeID=" + value.place_id);
                            if (res.data.model == "")
                                onChange(value.place_id);
                            else
                                setExistingToLocationId(res.data.model);
                  } else {
                    onChange(null);
                  }
                }}
                value={value}
                inputValue={value}
                name={name}
                onBlur={onBlur}
                error={errors.toOtherLocation}
                errorMessage={errors.toOtherLocation ? errors.toOtherLocation.message : ""}
              />
            )}
            rules={{
              validate: (value) => {
                if ((!value || !destinationGooglePlaceDetails) && toMode === 1) {
                  return "Location is required";
                }
              },
            }}
          />
        </Grid>
      );
    }
  };
  const changeFromModeToHospital = (e: React.MouseEvent<HTMLAnchorElement>): void => {
    e.preventDefault();
    // if (toMode === 0 && !authStore.data?.IsAdmin) {
    //   setToMode(1);
    // }
    setFromMode(0);
  };

  const changeFromModeToOtherLocation = (e: React.MouseEvent<HTMLAnchorElement>): void => {
    e.preventDefault();
    setFromMode(1);
  };

  const changeToModeToHospital = (e: React.MouseEvent<HTMLAnchorElement>): void => {
    e?.preventDefault();
    // if (fromMode === 0 && !authStore.data?.IsAdmin) {
    //   setFromMode(1);
    // }
    setToMode(0);
  };

  const changeToModeToOtherLocation = (e: React.MouseEvent<HTMLAnchorElement>): void => {
    e.preventDefault();
    setToMode(1);
  };

  useEffect(() => {
    if (fromMode == 0) {
      setValue("fromCustomerLocation", data.originCustomerLocationId);
      setValue("originBed", data.originBed || "");
      setValue("fromWard", data.originWardId || data.originWardId || "");
    } else {
      setValue("fromOtherLocation", data.originGooglePlaceId ?? null);
    }
  }, [fromMode]);

  useEffect(() => {
    if (toMode == 0) {
      setValue("toCustomerLocation", data.destinationCustomerLocationId);
      setValue("destinationBed", data.destinationBed || "");
      setValue("toWard", data.destinationWardId || data.destinationWardId || "");
    } else {
      setValue("toOtherLocation", data.destinationGooglePlaceId ?? null);
    }
  }, [toMode]);

  const handleRecentLocationClick = async (fieldName: string, locationId: string): Promise<void> => {
    setValue(fieldName, locationId);
    if (fieldName === "fromCustomerLocation") {
      setFromWards([]);
      await getFromWardsData(locationId, true);
    } else {
      setToWards([]);
      await getToWardsData(locationId, true);
    }
  };

  const renderRecentLocations = (type: string) => {
    if (recentLocations) {
      if (type === "from") {
        {
          return recentLocations
            .filter((item) => item.deleted != true)
            .map((item) => (
              <li key={item.value}>
                <Link
                  href="#"
                  onClick={(e: React.MouseEvent) => {
                    e.preventDefault();
                    handleRecentLocationClick("fromCustomerLocation", item.value === undefined ? "" : item.value);
                  }}
                >
                  {item.text}
                </Link>
              </li>
            ));
        }
      } else {
        return recentLocations
          .filter((item) => item.deleted != true)
          .map((item) => (
            <li key={item.value}>
              <Link
                href="#"
                onClick={(e: React.MouseEvent) => {
                  e.preventDefault();
                  handleRecentLocationClick("toCustomerLocation", item.value === undefined ? "" : item.value);
                }}
              >
                {item.text}
              </Link>
            </li>
          ));
      }
    }
  };
  useEffect(() => {
    setValue("originNote", currentDestinationDetails.note);
    setValue("fromCustomerLocation", currentDestinationDetails.customerLocation);
    setValue("originBed", currentDestinationDetails.bed);
    setFromWards(currentDestinationDetails.wards);
    setValue("fromWard", currentDestinationDetails.wardId);
    setValue("fromOtherLocation", currentDestinationDetails.googlePlaceDetails ? currentDestinationDetails.googlePlaceDetails.place_id : "");
    setOriginGooglePlaceDetails(currentDestinationDetails.googlePlaceDetails);

    setValue("destinationNote", currentOriginDetails.note);
    setValue("toCustomerLocation", currentOriginDetails.customerLocation);
    setValue("destinationBed", currentOriginDetails.bed);
    setToWards(currentOriginDetails.wards);
    setValue("toWard", currentOriginDetails.wardId);
    setValue("toOtherLocation", currentOriginDetails.googlePlaceDetails ? currentOriginDetails.googlePlaceDetails.place_id : "");
    setDestinationGooglPlaceDetails(currentOriginDetails.googlePlaceDetails);
  }, [reverseMode]);

  const reverseLocation = () => {
    setCurrentOriginDetails({
      customerLocation: getValues("fromCustomerLocation"),
      bed: getValues("originBed"),
      wards: fromWards,
      wardId: getValues("fromWard"),
      googlePlaceDetails: originGooglePlaceDetails,
      note: getValues("originNote"),
    });

    setCurrentDestinationDetails({
      customerLocation: getValues("toCustomerLocation"),
      bed: getValues("destinationBed"),
      wards: toWards,
      wardId: getValues("toWard"),
      googlePlaceDetails: destinationGooglePlaceDetails,
      note: getValues("destinationNote"),
    });
    let currentFromMode = fromMode;
    setFromMode(toMode);
    setToMode(currentFromMode);
    setReverseMode(!reverseMode);
  };

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit(handleNext)}>
        <Grid style={{ paddingTop: 40 }}>
          <Grid container spacing={3} alignItems="flex-start">
            <Grid item xs={6}>
              <Typography style={{ fontSize: 36, fontWeight: 900 }}>Origin & Destination</Typography>
            </Grid>
            <Grid item xs={6} style={{ textAlign: "right" }}>
              {!isEdit && <NextButton onClick={onNextButtonClick} />}
              <Button id="update_changes" style={{ display: "none" }} onClick={() => saveChanges(true)}></Button>
              <Button id="save_changes" style={{ display: "none" }} onClick={() => saveChanges(false)}></Button>
            </Grid>
            <Grid container item xs={5} spacing={1} justify="flex-start">
              <Grid item xs={4}>
                <Typography style={{ fontSize: 26 }}>From</Typography>
              </Grid>
              <Grid item xs={8} style={{ alignSelf: "center", textAlign: "right" }}>
                <Link href="#" style={{ fontWeight: fromMode === 0 ? "bold" : "normal" }} onClick={changeFromModeToHospital}>
                  Hospital
                </Link>
                <Link href="#" style={{ paddingLeft: 10, fontWeight: fromMode === 1 ? "bold" : "normal" }} onClick={changeFromModeToOtherLocation}>
                  Other Location
                </Link>
              </Grid>
              {renderFromLocation()}
              <Grid item xs={12} className={classes.formRow}>
                <div className={classes.formControlLabel}>Note</div>
                <Controller
                  name="originNote"
                  defaultValue=""
                  control={control}
                  render={({ onChange, onBlur, value, name }) => (
                    <TextField value={value} onChange={(event) => onChange(event.target.value)} variant="outlined" />
                  )}
                  rules={{}}
                />
              </Grid>
              <Grid
                item
                xs={12}
                className={classes.formRow}
                style={{ display: fromMode === 0 && recentLocations && recentLocations.length > 0 ? "block" : "none" }}
              >
                <div className={classes.formControlLabel}>RECENT LOCATIONS</div>

                <ul className={classes.recentLocationList}>{renderRecentLocations("from")}</ul>
              </Grid>
            </Grid>
            <Grid item xs={2} style={{ textAlign: "center", paddingTop: 68 }}>
              <IconButton aria-label="Reverse" style={{ color: "#0049a3" }} onClick={reverseLocation}>
                <SyncAltIcon />
              </IconButton>
            </Grid>
            <Grid container item xs={5} spacing={1}>
              <Grid item xs={3}>
                <Typography style={{ fontSize: 26 }}>To</Typography>
              </Grid>
              <Grid item xs={9} style={{ alignSelf: "center", textAlign: "right" }}>
                <Link href="#" style={{ fontWeight: toMode === 0 ? "bold" : "normal" }} onClick={changeToModeToHospital}>
                  Hospital
                </Link>
                <Link href="#" style={{ paddingLeft: 10, fontWeight: toMode === 1 ? "bold" : "normal" }} onClick={changeToModeToOtherLocation}>
                  Other Location
                </Link>
              </Grid>
              {renderToLocation()}
              <Grid item xs={12} className={classes.formRow}>
                <div className={classes.formControlLabel}>Note</div>
                <Controller
                  name="destinationNote"
                  defaultValue=""
                  control={control}
                  render={({ onChange, onBlur, value, name }) => (
                    <TextField value={value} onChange={(event) => onChange(event.target.value)} variant="outlined" />
                  )}
                  rules={{}}
                />
              </Grid>
              <Grid
                item
                xs={12}
                className={classes.formRow}
                style={{ display: toMode === 0 && recentLocations && recentLocations.length > 0 ? "block" : "none" }}
              >
                <div className={classes.formControlLabel}>RECENT LOCATIONS</div>

                <ul className={classes.recentLocationList}>{renderRecentLocations("to")}</ul>
              </Grid>
            </Grid>
            <Grid item xs={12} style={{ marginTop: 40, borderBottom: "1px solid #DADADA" }}>
              {toastAlert.open && <LinearProgress style={{ position: "relative", bottom: -14, width: "100%" }} />}
            </Grid>
            <Grid item xs={12} className={classes.formRow}>
              <div style={{ display: "block" }}>
                <Controller
                  name="returnTrip"
                  control={control}
                  defaultValue={false}
                  render={({ onChange, onBlur, value, name }) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          name={name}
                          style={{ padding: 4 }}
                          checked={value}
                          onChange={(e: React.ChangeEvent<any>) => onChange(e.target.checked)}
                        />
                      }
                      label="Return trip"
                    />
                  )}
                />
              </div>
              <div style={{ display: "block" }}>
                <Controller
                  name="escortRequired"
                  control={control}
                  defaultValue={false}
                  render={({ onChange, onBlur, value, name }) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          name={name}
                          style={{ padding: 4 }}
                          checked={value}
                          onChange={(e: React.ChangeEvent<any>) => onChange(e.target.checked)}
                        />
                      }
                      label="Patient companion or clinical escort required"
                    />
                  )}
                />
              </div>
            </Grid>
          </Grid>
        </Grid>
      </form>
      <Snackbar
        // Remove Snackbar if not required
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={toastAlert.open && false}
        message={toastAlert.message}
      />
    </React.Fragment>
  );
};

export default OriginDestination;
